import { SxProps, Theme } from "@mui/material";

export const appBarSx: SxProps<Theme> = {
  bgcolor: "rgba(11, 15, 23, 0.8)",
  backdropFilter: "blur(20px)",
  borderBottom: "1px solid rgba(30, 41, 59, 0.8)",
  top: 0,
};

export const toolbarSx: SxProps<Theme> = {
  maxWidth: 1440,
  width: "100%",
  mx: "auto",
  px: { xs: 2, sm: 3, lg: 4 },
  minHeight: 80,
  display: "flex",
  justifyContent: "space-between",
  gap: 2,
};

export const pillTrackSx = {
  display: "flex",
  alignItems: "center",
  gap: 0.5,
  bgcolor: "rgba(15, 23, 42, 0.8)",
  p: 0.75,
  borderRadius: 999,
  border: "1px solid rgba(30, 41, 59, 1)",
};

export const pillItemSx = (active: boolean) => ({
  px: 2,
  py: 1,
  borderRadius: 999,
  fontSize: "0.875rem",
  color: active ? "#fff" : "#cbd5e1",
  bgcolor: active ? "#7c3aed" : "transparent",
  boxShadow: active ? "0 4px 12px rgba(124, 58, 237, 0.35)" : "none",
  "&:hover": {
    bgcolor: active ? "#7c3aed" : "rgba(30, 41, 59, 0.5)",
    color: "#fff",
  },
  "& .MuiButton-startIcon": {
    color: active ? "#fff" : "#a78bfa",
  },
});

export const primaryActionSx: SxProps<Theme> = {
  px: 2.5,
  py: 1,
  borderRadius: 999,
  fontSize: "0.875rem",
  boxShadow: "0 4px 12px rgba(124, 58, 237, 0.35)",
};
